var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona_data",
    "data-name": "icona data",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_72",
    "data-name": "Raggruppa 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_71",
    "data-name": "Raggruppa 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26",
    "data-name": "Tracciato 26",
    d: "M14.286,1.714H12.571V.571a.571.571,0,1,0-1.143,0V1.714H4.571V.571a.571.571,0,1,0-1.143,0V1.714H1.714A1.714,1.714,0,0,0,0,3.429V14.286A1.714,1.714,0,0,0,1.714,16H14.286A1.714,1.714,0,0,0,16,14.286V3.429A1.714,1.714,0,0,0,14.286,1.714Zm.571,12.571a.571.571,0,0,1-.571.571H1.714a.571.571,0,0,1-.571-.571V6.857H14.857Zm0-8.571H1.143V3.429a.571.571,0,0,1,.571-.571H3.429V4A.571.571,0,1,0,4.571,4V2.857h6.857V4a.571.571,0,1,0,1.143,0V2.857h1.714a.571.571,0,0,1,.571.571V5.714Z",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_74",
    "data-name": "Raggruppa 74",
    transform: "translate(2.857 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_73",
    "data-name": "Raggruppa 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_27",
    "data-name": "Tracciato 27",
    d: "M87.047,238.933H85.9a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-85.333 -238.933)",
    fill: "currentColor"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_76",
    "data-name": "Raggruppa 76",
    transform: "translate(6.857 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_75",
    "data-name": "Raggruppa 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_28",
    "data-name": "Tracciato 28",
    d: "M206.514,238.933h-1.143a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-204.8 -238.933)",
    fill: "currentColor"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_78",
    "data-name": "Raggruppa 78",
    transform: "translate(10.857 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_77",
    "data-name": "Raggruppa 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_29",
    "data-name": "Tracciato 29",
    d: "M325.981,238.933h-1.143a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-324.267 -238.933)",
    fill: "currentColor"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_80",
    "data-name": "Raggruppa 80",
    transform: "translate(2.857 10.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_79",
    "data-name": "Raggruppa 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_30",
    "data-name": "Tracciato 30",
    d: "M87.047,307.2H85.9a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-85.333 -307.2)",
    fill: "currentColor"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_82",
    "data-name": "Raggruppa 82",
    transform: "translate(6.857 10.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_81",
    "data-name": "Raggruppa 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_31",
    "data-name": "Tracciato 31",
    d: "M206.514,307.2h-1.143a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-204.8 -307.2)",
    fill: "currentColor"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_84",
    "data-name": "Raggruppa 84",
    transform: "translate(10.857 10.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_83",
    "data-name": "Raggruppa 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32",
    "data-name": "Tracciato 32",
    d: "M325.981,307.2h-1.143a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-324.267 -307.2)",
    fill: "currentColor"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_86",
    "data-name": "Raggruppa 86",
    transform: "translate(2.857 12.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_85",
    "data-name": "Raggruppa 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33",
    "data-name": "Tracciato 33",
    d: "M87.047,375.467H85.9a.571.571,0,0,0,0,1.143h1.143a.571.571,0,1,0,0-1.143Z",
    transform: "translate(-85.333 -375.467)",
    fill: "currentColor"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_88",
    "data-name": "Raggruppa 88",
    transform: "translate(6.857 12.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_87",
    "data-name": "Raggruppa 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34",
    "data-name": "Tracciato 34",
    d: "M206.514,375.467h-1.143a.571.571,0,1,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-204.8 -375.467)",
    fill: "currentColor"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_90",
    "data-name": "Raggruppa 90",
    transform: "translate(10.857 12.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_89",
    "data-name": "Raggruppa 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35",
    "data-name": "Tracciato 35",
    d: "M325.981,375.467h-1.143a.571.571,0,0,0,0,1.143h1.143a.571.571,0,0,0,0-1.143Z",
    transform: "translate(-324.267 -375.467)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar_date.fb081a145cdb8473f5b71836d77d5d1a.svg";
export { ForwardRef as ReactComponent };